import React from 'react';
import { IIconProps } from '../interfaces';

const Edit2Icon = (props: IIconProps) => {

    return (
        <svg
            width={ props.width }
            height={ props.width }
            className={ props.classes }
            viewBox="0 0 24 25"
            xmlns="http://www.w3.org/2000/svg"
            fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M6.00576 22.9136L1.68584 23.5406C1.511 23.566 1.47194 23.5142 1.51751 23.3186L2.68469 18.373L19.5949 2.2148C19.7772 2.04033 20.0571 2.06888 20.2069 2.2719L23.0015 6.05954C23.1531 6.26363 23.1262 6.5819 22.9448 6.75533L6.00576 22.9136Z" stroke={props.color} strokeWidth="1.17"/>
            <path d="M17.25 4.5L20.508 8.92394" stroke={props.color} strokeWidth="0.9"/>
            <path d="M2.79626 18.1843L6.68426 22.5711" stroke={props.color} strokeWidth="0.9"/>
            <title>{ props.title }</title>

        </svg>)
};

export default Edit2Icon;
